var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM13.8,6.9c0-3.2-2.6-5.8-5.8-5.8S2.2,3.7,2.2,6.9c0,2,1,3.7,2.5,4.8l3.3,3.1l4.1-3.9C13.2,10,13.8,8.5,13.8,6.9z","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.5,5 4.5,9 8,11 11.5,9 11.5,5 8,3 \t","key":1}),React.createElement("polygon",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t6.8,6.3 6.8,7.7 8,8.4 9.2,7.7 9.2,6.3 8,5.6 \t","key":2})]));
}

Location.displayName = "Location";

Location.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Location;

Location.default = Location;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/location.svg
// module id = ../icon/src/icons/location.svg
// module chunks = 0